<template>
  <div>
    <div class="settori">
      <common-hero :background="pageApiData.cover" :tag="'div'">
        <h1 class="common-hero__processing-order">{{ pageApiData.title }}</h1>
        <h2 class="internal-title" v-html="pageApiData.description"></h2>
      </common-hero>

      <inner-menu
        :list="innerMenuList"
        :parent-route-name="$route.name"
        @user-click="$_scrollToHash" />

      <section class="listing-settori">
        <article
        v-for="(section, index) of pageApiData.sections"
        v-update-route="$router.replace.bind($router, { name: $route.name, hash: `#${section.slug}` })"
        v-animate-on-intersection
        :key="index"
        :id="section.slug">
          <picture>
            <source :srcset="imgServer + section.images.mobile" media="(max-width: 1023px)">
            <source :srcset="imgServer + section.images.desktop" media="(min-width: 1024px)">
            <img :src="imgServer + section.images.desktop" :alt="section.title">
          </picture>
          <div class="listing-settori--absolute-area">
            <div class="default-container">
              <div v-animate-on-intersection class="settori_section">
                <div class="settori_section__content">
                  <div v-html="section.description"></div>
                  <router-link
                    :to="{ name: `${lang}-richiesta-contatti`, params: { lang } }"
                    class="link-triangle-effect"
                    style="padding: 16px 35px 16px 0;">
                    {{ section.textLink }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    </div>
    <section class="bottom-cta">
      <div class="default-container">
        <h3>{{ pageApiData.sectorscta_title }}</h3>
        <p v-html="pageApiData.sectorscta_content"></p>
        <router-link
          :to="{ name: `${lang}-richiesta-contatti`, params: { lang } }"
          class="link-triangle-effect">
          {{ textLink }}
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import _ from 'lodash'
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import CommonHero from '@/components/CommonHero'
import InnerMenu from '@/components/InnerMenu'

export default {
  mixins: [ lang, dataLoad ],
  name: 'home',
  components: {
    CommonHero,
    InnerMenu
  },
  props: {
    hash: {
      type: String,
      required: false
    }
  },
  computed: {
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    },
    innerMenuList: {
      get () {
        return _.map(this.pageApiData.sections, ({ slug, title }) => ({
          hash: `#${slug}`,
          title
        }))
      }
    },
    textLink: {
      get () {
        if (window.matchMedia('(max-width: 700px)').matches) return this.pageApiData.sectorscta_cta_small
        return this.pageApiData.sectorscta_cta
      }
    }
  },
  directives: {
    'update-route': {
      bind (el, binding) {
        const threshold = 0.25
        const observer = new window.IntersectionObserver(entries => {
          _.forEach(entries, entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= threshold) binding.value()
          })
        }, { threshold })

        observer.observe(el)
      }
    }
  }
}
</script>

<style lang="scss">
@import "../assets/mixins/breakpoints";
@import "../assets/mixins/typo";

.listing-settori{
  background-color:#FFF;
  top: -85px;
  article{
    display: flex;
    position: relative;
    flex-wrap: wrap;
    @media #{$large_mq} {
      flex-wrap: nowrap
    }
  }
  article:nth-child(odd){
    @media #{$large_mq} {
      flex-direction: row-reverse;
    }
    .settori_section{
      margin-left: 0;
    }
  }

  picture{
    width: 100%;
    @media #{$large_mq} {
      width: 50%;
    }
    img{
        width: 100%; height: auto;
        display: block;
      }
  }

  .listing-settori--absolute-area{
    margin: 4rem 0 8rem;
    @media #{$large_mq} {
      margin: 0;
      position: absolute; width: 100%;
      left: 0; top: 0; height: 100%;
      .default-container, .settori_section{
        height: 100%;
      }
    }
  }

  .settori_section{
    @media #{$large_mq} {
      width: 40%;
      margin-left: 60%;
      .settori_section__content{
        top: 50%;
        transform: translate3d(0, -50%, 0);
      }
    }
  }

  .settori_section__content{
    h3{
      @include size-16-pixel(#4A4A4A);
      letter-spacing: .2rem;
      font-family: 'Roboto', sans-serif;
      font-weight: 500; line-height: 1.2;
      text-transform: uppercase;
      margin-bottom: 1.5rem;
      margin-top: 0;
    }
    h2{
      @include hero-title(#4A4A4A);
      margin-top: 0;
      br{
        display: none;
        @media #{$large_mq} {
          display: none;
        }
      }
    }
    p{
      @include size-18-pixel(#4A4A4A);
      font-family: 'Roboto', sans-serif;
      font-weight: 300; line-height: 1.8;
      margin-bottom: 0;
    }
    .link-triangle-effect{
      margin-top: 1.5rem;
      transition: all .8s cubic-bezier(.23,1,.32,1);
      @include link-triangle-effect(#4A4A4A);
      &::after{
        background-image: url("data:image/svg+xml,%3Csvg width='11px' height='11px' viewBox='0 0 11 11' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='SIMBOLI' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='btn1' transform='translate(-228.000000, -4.000000)' fill='%234A4A4A' fill-rule='nonzero'%3E%3Cpath d='M236.896,9.488 L228.928,5.504 L228.928,13.472 L236.896,9.488 Z M228,4 L238.976,9.488 L228,14.976 L228,4 Z' id='3'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        transition: all .8s cubic-bezier(.23,1,.32,1);
      }
      &::before{
        display: none;
      }
      &:hover{
        @include link-triangle-effect(#679196);
      }
      &:hover::after{
        background-image: url("data:image/svg+xml,%3Csvg width='11px' height='11px' viewBox='0 0 11 11' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='SIMBOLI' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='btn1' transform='translate(-228.000000, -4.000000)' fill='%23304FFE' fill-rule='nonzero'%3E%3Cpath d='M236.896,9.488 L228.928,5.504 L228.928,13.472 L236.896,9.488 Z M228,4 L238.976,9.488 L228,14.976 L228,4 Z' id='3'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      }
    }
  }
}

.listing-settori .settori_section__content a.link-triangle-effect{
  padding: 0 35px 0 0;
}

</style>
